<!--
    描述：企业账户弹窗
    时间：2021-08-11
    Created by 王帅
-->
<template>
    <div>
        <!-- 申请步骤 -->
        <div class="apply-container" v-loading="applyDialog.btnLoading">
            <!-- 头部说明文字 -->
            <p class="apply-title">
                <template v-if="applyDialog.mode === 'pay'">提醒: 完成以下3个步骤，企业可以在平台上进行相关业务支付。</template>
                <template v-if="applyDialog.mode === 'account'">提醒:
                    完成前3个步骤，企业可以在平台上进行相关业务支付，完成全部4个步骤，企业可以在平台上进行业务收款、账户提现
                </template>
            </p>

            <!-- 进度图标 -->
            <div class="apply-progress">
                <ul class="flex">
                    <li v-for="(item, index) in accountList"
                        :key="'step' + index"
                        class="progress-box"
                        :class="{ 'success-box': item.isFlag === 1 }">
                        <span class="serial">{{ `0${index + 1}` }}</span>{{ item.sname }}
                    </li>
                </ul>
            </div>

            <!-- 步骤文字、按钮 -->
            <div class="apply-text">
                <p v-for="(item, index) in accountList"
                   :key="'text' + index"
                   class="text-block">
                    <i class="success-icon el-icon-success text-icon"
                       v-if="item.isFlag === 1"></i>
                    <i class="error-icon el-icon-close text-icon"
                       v-else-if="item.isFlag === 2"></i>
                    <i class="warning-icon el-icon-warning text-icon"
                       v-else></i>
                    {{ item.sname + "&nbsp;&nbsp;" }}
                    <span class="color-red ml10">{{ item.title }}</span>
                    <el-button :type="item.isFlag === 1 ? '' : 'primary'"
                               size="mini"
                               @click="onStepClick(item.key, item.isFlag)"
                               class="fr"
                               v-show="!(item.key === '1002' && item.isFlag === 1)"
                               :disabled="accountList[0].isFlag !== 1 && index !== 0">{{ item.isFlag !== -1 &&
                        item.isFlag !== 2 ? '点击查看' : '立即前往'}}
                    </el-button>
                </p>
                <p class="text-tips">
                    温馨提示：</br>完成以上操作后，请关闭该弹窗页面
                </p>
            </div>
        </div>

        <!-- 第一步 ——— 基本信息弹窗 -->
        <el-dialog :visible.sync="infoDialog.visible"
                   :width="infoDialog.width"
                   :title="infoDialog.title"
                   center
                   append-to-body
                   :close-on-click-modal="false">
            <el-form ref="accountForm"
                     :model="accountForm"
                     :rules="accountRules"
                     label-width="180px"
                     v-loading="infoDialog.btnLoading">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="企业名称："
                                      prop="sname">
                            <el-input disabled
                                      v-model="accountForm.sname"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="企业类型："
                                      prop="flatType">
                            <el-select v-model="accountForm.flatType"
                                       disabled>
                                <el-option v-for="(item, index) in qylx"
                                           :key="'企业类型' + index"
                                           :value="item.value"
                                           :label="item.sname">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="统一社会信用代码："
                                      prop="code">
                            <el-input disabled
                                      v-model="accountForm.code"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="法人代表姓名："
                                      prop="legaler">
                            <el-input disabled
                                      v-model="accountForm.legaler"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="法人代表手机号："
                                      prop="legalPhone">
                            <el-input :disabled="infoDisabled"
                                      v-model="accountForm.legalPhone"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="法人代表证件类型："
                                      prop="cardType">
                            <el-select v-model="accountForm.cardType"
                                       :disabled="infoDisabled"
                                       filterable
                                       clearable>
                                <el-option v-for="(item, index) in zjlx"
                                           :key="'证件类型' + index"
                                           :value="item.value"
                                           :label="item.sname">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="法人代表证件号："
                                      prop="idCard">
                            <el-input :disabled="infoDisabled"
                                      v-model="accountForm.idCard"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="开户行："
                                      prop="bank">
                            <el-select v-model="accountForm.bank"
                                       :disabled="infoDisabled"
                                       filterable
                                       clearable>
                                <el-option v-for="(m, n) in khh"
                                           :key="'khh' + n"
                                           :label="m.sname"
                                           :value="m.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="对公账户："
                                      prop="account">
                            <el-input :disabled="infoDisabled"
                                      v-model="accountForm.account"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="开户行支行名称："
                                      prop="branchBank">
                            <el-select popper-class="branch-bank" v-model="accountForm.branchBank"
                                       :disabled="infoDisabled" filterable remote :remote-method="onBankSearch"
                                       clearable allow-create default-first-option @clear="onBankClear"
                                       @change="onSelectBranch"
                            >
                                <el-option :value="''" class="btn-select">
                                    <span>合计匹配到：{{ branchObj.total }} 条</span>
                                    <el-button size="mini" type="primary"
                                               icon="el-icon-refresh"
                                               class="ml10"
                                               :disabled="branchObj.current === branchObj.maxPage"
                                               @click.stop.prevent="onBankClick">
                                        换一批
                                    </el-button>
                                </el-option>
                                <el-option v-for="(item, index) in branchObj.banks"
                                           :key="'branch' + index"
                                           :label="item.bankName"
                                           :value="item.bankName"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="支付行行号："
                                      prop="payNo">
                            <el-input :disabled="infoDisabled"
                                      v-model="accountForm.payNo">
                                <template slot="append">
                                    <a href="https://www.hebbank.com/corporbank/otherBankQueryWeb.do"
                                       target="_blank"
                                       class="font14">支付行行号查询</a>
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!-- 第二步 ——— 通联协议弹窗 -->
        <el-dialog :visible.sync="agreementDialog.visible"
                   :title="agreementDialog.title"
                   :width="agreementDialog.width"
                   :close-on-click-modal="false"
                   class="addPay"
                   fullscreen
                   v-loading="pageLoading"
                   :element-loading-text="`正在查询协议签署状态，请耐心等候, ${loadingTime}s...`"
                   :before-close="onBeforeClose"
                   center>
            <div class="agreement-main h100">
                <iframe :src="openUrl"
                        frameborder="0"
                        height="100%"
                        width="100%"></iframe>
            </div>
        </el-dialog>

        <!-- 第三步 ——— 手机号绑定 -->
        <el-dialog :visible.sync="phoneDialog.visible"
                   :title="phoneDialog.title"
                   :width="phoneDialog.width"
                   :close-on-click-modal="false"
                   append-to-body
                   top="20vh"
                   center>
            <p class="phone-text">提示：接收支付/提现资金短信的手机号</p>
            <el-form :model="phoneForm"
                     label-width="140px"
                     :rules="phoneRule"
                     class="phone-form"
                     ref="phoneForm"
                     v-loading="phoneDialog.btnLoading">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="短信接收手机号："
                                      prop="tiedPhone">
                            <el-input v-model="phoneForm.tiedPhone"
                                      class="mr10"
                                      maxlength="11"
                                      :disabled="phoneDialog.mode === 'view'"
                                      placeholder="短信接收手机号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!-- 第四步 ——— 影印件资料 -->
        <el-dialog :visible.sync="fileDialog.visible"
                   :width="fileDialog.width"
                   :title="fileDialog.title"
                   center
                   append-to-body
                   :close-on-click-modal="false">
            <!-- 内容 -->
            <p class="error-header"
               v-if="licenseFlag === 2 || cardFlag === 2">
                审核失败原因提示：<span>{{ errorText }}</span>
            </p>
            <el-form ref="fileForm"
                     :model="fileForm"
                     v-if="fileDialog.visible"
                     v-loading="fileDialog.btnLoading"
                     label-width="180px">
                <el-form-item label="营业执照："
                              required>
                    <div class="upload-flex">
                        <img class="file-img" :src="`${uploadUrl}${fileObj.license_zz_Url}`" alt="营业执照">
                    </div>
                </el-form-item>
                <el-form-item label="法定代表人身份证原件："
                              required>
                    <div class="flex">
                        <img class="file-img" :src="`${uploadUrl}${fileObj.idCardZ_Url}`" alt="身份证正面">
                        <img class="file-img ml20" :src="`${uploadUrl}${fileObj.idCardF_Url}`" alt="身份证反面">
                    </div>
                    <p style="color: #256ccb">
                        温馨提示：图片大小500k以内，支持格式 'jpg', 'jpeg', 'JPG', 'JPEG'
                    </p>
                    <!-- <p>温馨提示：上传文件不超过2M，扫描件或复印件。格式为JPG\JPEG\PNG</p> -->
                </el-form-item>
            </el-form>

            <div class="footer text-center" v-if="showFileBtn">
                <el-button size="small"
                           class="btn"
                           @click="fileDialog.visible = false">返回
                </el-button>
                <el-button type="primary"
                           size="small"
                           class="btn btn-blue"
                           @click="doSubmit(1)"
                           :loading="fileDialog.btnLoading">提交
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {dateFormat} from "utils/tools";
    // 企业账户js
    import * as Api from 'api/modules/account'

    export default {
        props: {
            // 基础信息
            infoObj: {
                type: Object,
                default: () => {
                    return {
                        accountState: 0,	// 是否有账户	3: 可提现  2：可支付  1: 审核中  0：待创建
                        bizUserid: '',
                        memberId: '',
                        tenantId: '',
                        accountId: '',
                        legalPhone: '',
                    }
                }
            },
            // 账户步骤
            accountList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            // 影像件对象
            fileObj: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        data() {
            return {
                curStepList: [],
                curKey: '',
                currentBranch: '',
                branchObj: {
                    size: 20,
                    current: 1,
                    bankName: '',
                    banks: [],
                    maxPage: 1,
                    total: 0
                },
                // 显示步骤弹窗
                applyDialog: {
                    visible: false,
                    width: '900px',
                    title: '设置企业资金账户',
                    // title: "设置企业支付功能",
                    btnLoading: false,
                    desc: '',
                    mode: 'account', // 支持 账户(account) 和 支付(pay) 两种展示模式
                    // mode: 'pay',    // 支持 账户(account) 和 支付(pay) 两种展示模式
                },
                // 第一步——基本信息弹窗
                baseState: 0,
                infoDialog: {
                    visible: false,
                    width: '80%',
                    title: '添加收款账户',
                    btnLoading: false,
                    mode: 'add',
                },
                baseInfo: [],
                accountForm: {
                    sname: '',
                    flatType: '',
                    code: '',
                    legaler: '',
                    idCard: '',
                    cardType: '',
                    legalPhone: '',
                    bank: '',
                    account: '',
                    branchBank: '',
                    payNo: '',
                },
                accountRules: {
                    sname: [
                        {
                            required: true,
                            message: '企业名称不能为空',
                            trigger: 'blur',
                        },
                    ],
                    flatType: [
                        {
                            required: true,
                            message: '企业类型不能为空',
                            trigger: 'change',
                        },
                    ],
                    code: [
                        {
                            required: true,
                            message: '统一社会信用代码不能为空',
                            trigger: 'blur',
                        },
                    ],
                    legaler: [
                        {
                            required: true,
                            message: '法人代表姓名不能为空',
                            trigger: 'blur',
                        },
                    ],
                    legalPhone: [
                        {
                            required: true,
                            message: '法人代表手机号不能为空',
                            trigger: 'blur',
                        },
                        {
                            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                            message: '手机号码格式有误！',
                            trigger: 'blur',
                        },
                    ],
                    cardType: [
                        {
                            required: true,
                            message: '证件类型不能为空',
                            trigger: 'change',
                        },
                    ],
                    idCard: [
                        {
                            required: true,
                            message: '法定代表人身份证号不能为空',
                            trigger: 'blur',
                        },
                    ],
                    bank: [
                        {
                            required: true,
                            message: '开户行不能为空',
                            trigger: 'change',
                            // trigger: "blur",
                        },
                    ],
                    account: [
                        {
                            required: true,
                            message: '对公账户不能为空',
                            trigger: 'blur',
                        },
                        {
                            // pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/,
                            pattern: /^[0-9]{9,24}$/,
                            message: '请输入9-24位数字！',
                            trigger: 'blur',
                        },
                    ],
                    branchBank: [
                        {
                            required: true,
                            message: '开户支行名称不能为空',
                            trigger: 'change',
                        },
                        {
                            pattern: /^[\u4E00-\u9FA5]+$/,
                            message: '请输入中文！',
                            trigger: 'change',
                        },
                    ],
                    payNo: [
                        {
                            required: true,
                            message: '支付联行号不能为空',
                            trigger: 'blur',
                        },
                        {
                            pattern: /^[0-9]{12}$/,
                            message: '请输入12位数的支付行号！',
                            trigger: 'blur',
                        },
                    ],
                },
                accountId: '', // 数据库存记录主键ID
                // 第二步 —— 协议弹窗
                agreementDialog: {
                    visible: false,
                    width: '80%',
                    title: '通联支付网络交易资金管理服务三方协议',
                    btnLoading: false,
                    mode: 'add',
                },
                agreementState: '已签署',
                openUrl: '',
                // 手机号弹窗
                phoneDialog: {
                    visible: false,
                    width: '600px',
                    title: '手机号绑定',
                    btnLoading: false,
                    codeText: '点击获取验证码', // 验证码按钮显示文字
                    mode: 'add',
                },
                phoneCount: 60,
                phoneForm: {
                    tiedPhone: '',
                    verificationCode: '',
                },
                phoneRule: {
                    tiedPhone: [
                        {
                            required: true,
                            message: '手机号不能为空',
                            trigger: 'blur',
                        },
                        {
                            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                            message: '手机号码格式有误！',
                            trigger: 'blur',
                        },
                    ],
                    verificationCode: [
                        {
                            required: true,
                            message: '验证码不能为空',
                            trigger: 'blur',
                        },
                    ],
                },
                phoneState: 0, // 1 是已绑定， 0是 未绑定
                // 第四步 —— 影印件弹窗
                fileDialog: {
                    visible: false,
                    width: '900px',
                    title: '上传影像件材料',
                    btnLoading: false,
                    mode: 'add',
                },
                fileForm: {},
                licenseMode: 'add',
                cardMode: 'add',
                licenseFlag: -1,
                cardFlag: -1,
                // 定时器相关、loading
                pageLoading: false,
                loadingTime: 15,
                // loadingTime: 30,
                loadingInterval: null,
                codeInterval: null,
                agreeInterval: null,
                agreeTime: 5,
            }
        },
        created() {
            // this.getBranchBanks()
            let _base = this.accountList.find(x => x.type === 0)
            if (_base?.accountInfo) {
                this.accountForm = _base.accountInfo
            }

            let _phone = this.accountList.find(x => x.type === 4)
            if (_phone?.bindPhone) {
                this.phoneForm.tiedPhone = _phone.bindPhone
            }
        },
        methods: {
            // 点击支行
            onBankSearch(query) {
                this.branchObj.current = 1
                if (query.replace(/\s+/g, '') !== '') {
                    this.currentBranch = query
                    // this.loading = true;
                    setTimeout(() => {
                        // this.loading = false;
                        this.getBranchBanks(query)
                    }, 200);
                } else {
                    this.currentBranch = ''
                    console.log(111)
                    this.getBranchBanks(this.currentBranch)
                }
            },

            // 点击换一批
            onBankClick() {
                this.branchObj.current++
                if (this.branchObj.current > this.branchObj.maxPage) {
                    this.branchObj.current = 1
                }
                this.getBranchBanks(this.currentBranch)
            },

            // 清空
            onBankClear() {
                this.branchObj.current = 1
                this.currentBranch = ''
                this.getBranchBanks(this.currentBranch)
            },

            // 获取支行列表
            getBranchBanks(name) {
                let params = {
                    size: this.branchObj.size,
                    current: this.branchObj.current,
                    bankName: name || '',
                }
                Api.getPageBanks(params)
                    .then(res => {
                        this.branchObj.banks = res.data.records
                        // 总页数
                        this.branchObj.maxPage = parseInt(res.data.pages)
                        this.branchObj.total = parseInt(res.data.total)
                    })
                    .catch(() => {
                        this.branchObj.banks = []
                        this.branchObj.maxPage = 1
                        this.branchObj.total = 0
                    })
            },

            // 选择分行时
            onSelectBranch(val) {
                let _item = this.branchObj.banks.find(x => x.bankName === val)
                if (_item) {
                    this.accountForm.payNo = _item.payNo
                } else {
                    this.accountForm.payNo = ''
                }
            },

            // 根据 模式 获取企业账户步骤完成情况
            getStepList(isFirst) {
                // 只有首次加载时  选取默认数组, 否则沿用当前数组
                if (isFirst) {
                    this.curStepList = JSON.parse(JSON.stringify(this.stepList))
                }

                // Api.getRecordsState({memberId: this.infoObj.memberId})
                //     .then(res => {
                //         setTimeout(() => {
                //             this.applyDialog.btnLoading = false
                //         }, 500)
                //
                //         // 如果基础信息的状态是 1，审核通过
                //         if (res.data.baseFlag === 1) {
                //             this.baseState = 1
                //         }
                //
                //         // 设置基本信息flag
                //         this.curStepList.find(x => x.key === '1001').isFlag = res.data.baseFlag
                //
                //         // 设置协议flag
                //         this.curStepList.find(x => x.key === '1002').isFlag = res.data.protocolFlag
                //
                //         // 设置手机号flag
                //         this.curStepList.find(x => x.key === '1003').isFlag = res.data.phoneFlag
                //
                //         // 设置影像件flag
                //         this.curStepList.find(x => x.key === '1004').isFlag = res.data.pictureFlag
                //
                //         // 如果基本信息报错，清除定时器
                //         if (res.data.baseFlag === 2) {
                //             this.$parent.clearAllInterval()
                //         }
                //
                //         // 全部通过清除定时器
                //         if (res.data.baseFlag === 1 && res.data.protocolFlag === 1 && res.data.phoneFlag === 1 && res.data.pictureFlag === 1) {
                //             this.$parent.clearAllInterval()
                //             this.$parent.getAccountInfo()
                //         }
                //     })
                //     .catch(err => {
                //         this.applyDialog.btnLoading = false
                //     })
            },

            // 点击 步骤模式是 查看 还是 完善信息
            onStepClick(key, flag) {
                this.curKey = key
                switch (key) {
                    // 完善基本信息
                    case '1001':
                        this.infoDialog.visible = true
                        this.infoDialog.mode = 'view'
                        break
                    // 签署会员协议
                    case '1002':
                        this.agreementDialog.mode = 'view'
                        break
                    // 绑定手机号
                    case '1003':
                        this.phoneDialog.visible = true
                        this.phoneDialog.mode = 'view'
                        break
                    // 上传影像材料
                    case '1004':
                        this.fileDialog.visible = true
                        this.fileDialog.mode = 'view'
                        this.licenseMode = 'view'
                        this.cardMode = 'view'
                        break
                }
            },

            // 获取企业基础信息 -- over
            getBaseInfo() {
                let params = {
                    type: this.baseState === 1 ? this.baseState : this.infoObj.accountState,
                    tenantId: this.infoObj.tenantId
                }
                Api.getAccountBase(params)
                    .then(res => {
                        if (res.data) {
                            this.accountForm.sname = res.data.sname
                            this.accountForm.flatType = res.data.flatType
                            this.accountForm.code = res.data.code
                            this.accountForm.legaler = res.data.legaler
                            this.accountForm.legalPhone = res.data.legalPhone
                            this.accountForm.cardType = res.data.cardType
                            this.accountForm.idCard = res.data.idCard

                            this.accountForm.bank = res.data.bank || ''
                            this.accountForm.branchBank = res.data.branchBank || ''
                            this.accountForm.account = res.data.account || ''
                            this.accountForm.payNo = res.data.payNo || ''
                        }
                    })
            },

            // 打开协议 -- over
            openAgreement() {
                let params = {
                    bizUserid: this.infoObj.bizUserid,
                    accountId: this.infoObj.accountId,
                }
                Api.doSign(params)
                    .then(res => {
                        if (res.code === 0) {
                            this.openUrl = res.data
                            this.agreementDialog.visible = true
                        }
                    })
                    .catch(err => {
                    })
            },

            // 点击提交各项步骤 -- over
            doSubmit(type) {
                switch (type) {
                    // 企业基本信息提交
                    case 0:
                        // 表单项验证
                        this.infoDialog.btnLoading = true

                        this.$refs.accountForm.validate((valid) => {
                            if (valid) {
                                // 接口保存
                                let params = this.$utils.clone(this.accountForm, true)
                                params.bizUserid = this.infoObj.bizUserid
                                params.memberId = this.infoObj.memberId

                                let bank = this.khh.find(x => x.value === params.bank)
                                params.bankName = bank ? bank.sname : ''
                                this.apiSave(type, params)
                            } else {
                                this.cancelLoading()
                            }
                        })
                        break;
                    // 手机号
                    case 4:
                        this.phoneDialog.btnLoading = true

                        this.$refs.phoneForm.validate((valid) => {
                            if (valid) {
                                let params = {
                                    bizUserid: this.infoObj.bizUserid,
                                    accountId: this.infoObj.accountId,
                                    tiedPhone: this.phoneForm.tiedPhone,
                                    verificationCode: this.phoneForm.verificationCode
                                }

                                this.apiSave(type, params)
                            } else {
                                this.cancelLoading()
                            }
                        })
                        break;
                    // 影像件
                    case 1:
                        this.fileDialog.btnLoading = true

                        let params = {
                            file1: this.$refs.codeUpload.addList,
                            file2: this.$refs.idCardZ.addList,
                            file3: this.$refs.idCardF.addList,
                        }

                        let _file1 = (params.file1.length === 0 && this.licenseFlag === -1) || (params.file1.length === 0 && this.licenseFlag === 2)
                        let _file2 = (params.file2.length === 0 && this.cardFlag === -1) || (params.file2.length === 0 && this.cardFlag === 2)
                        let _file3 = (params.file3.length === 0 && this.cardFlag === -1) || (params.file3.length === 0 && this.cardFlag === 2)

                        // 查看是否上传了
                        if (_file1) {
                            this.$message.warning("请上传营业执照!");
                            this.cancelLoading()
                            return
                        }
                        if (_file2) {
                            this.$message.warning("请上传身份证人像面!");
                            this.cancelLoading()
                            return
                        }
                        if (_file3) {
                            this.$message.warning("请上传身份证国徽面!");
                            this.cancelLoading()
                            return
                        }

                        // 2s 后加载loading
                        setTimeout(() => {
                            this.$message.warning('影像件审核时间较长，请稍候查询结果！')
                            this.handleClosed(1)
                        }, 2000)

                        // 接口保存
                        this.pictureSave(1, params.file1[0], this.infoObj.accountId)

                        this.pictureSave(8, params.file2[0], this.infoObj.accountId)

                        this.pictureSave(9, params.file3[0], this.infoObj.accountId)
                }
            },

            // 影像件上传 特殊处理 -- over
            pictureSave(type, list, memberId) {
                // 上传服务器
                this.saveToWeb(memberId, type);

                let formData = new FormData();
                formData.append("file", list);
                formData.append("path", dateFormat("yyyy-mm-dd"));
                formData.append("output", "json");
                formData.append("bizUserid", this.infoObj.bizUserid);
                formData.append("accountId", this.infoObj.accountId);
                formData.append("picType", type);

                if (list) {
                    this.apiSave(1, formData)
                }
            },

            // 图片上传服务器 -- over
            saveToWeb(id, type) {
                switch (type) {
                    case 1:
                        this.$refs.codeUpload.fileSend(id);
                        break;
                    case 8:
                        this.$refs.idCardZ.fileSend(id);
                        break;
                    case 9:
                        this.$refs.idCardF.fileSend(id);
                        break;
                }
            },

            // 接口保存 -- over
            apiSave(type, params) {
                switch (type) {
                    // 基本信息
                    case 0:
                        Api.saveAccountBase(params)
                            .then(res => {
                                // 重载开户信息
                                this.$parent.getAccountInfo()
                                // 保存成功后开始 查询状态
                                this.onLoading(type, res.data.id)
                            })
                            .catch(err => {
                                this.cancelLoading()
                            })
                        break
                    // 手机号
                    case 4:
                        Api.bindPhone(params)
                            .then(res => {
                                // this.handleClosed(type)
                                // 重载开户信息
                                this.$parent.getAccountInfo()
                                // 保存成功后开始 查询状态
                                this.onLoading(type, this.infoObj.accountId)
                            })
                            .catch(err => {
                                this.cancelLoading()
                            })
                        break
                    // 影像件
                    default:
                        Api.pictureCollect(params)
                            .then(res => {
                                // this.handleClosed(type)
                                // this.onLoading(type, this.infoObj.accountId)
                            })
                            .catch(err => {
                                this.cancelLoading()
                            })
                }
            },

            // 查询步骤数据库状态
            getStepStatus(type, accountId) {
                if (type === 1) {
                    let params = {
                        accountId: this.infoObj.accountId,
                        bizUserid: this.infoObj.bizUserid
                    }
                    Api.getPictureState(params)
                        .then(res => {
                            this.licenseMode = res.data.licenseFlag === 2 || res.data.licenseFlag === -1 ? 'add' : 'view'
                            this.cardMode = res.data.cardFlag === 2 || res.data.cardFlag === -1 ? 'add' : 'view'
                            this.licenseFlag = res.data.licenseFlag
                            this.cardFlag = res.data.cardFlag
                            // licenseFlag/cardFlag
                        })
                        .catch(err => {
                        })
                } else {
                    let params = {
                        type: type,
                        accountId: accountId,
                        bizUserid: this.infoObj.bizUserid
                    }
                    Api.getStepState(params)
                        .then(res => {
                            if (res.data.state === 1) {
                                // 防止同时查询
                                setTimeout(() => {
                                    this.handleClosed(type)
                                    this.getStepList()
                                }, 500)
                            } else if (res.data.state === 2) {
                                this.$message.error('审核失败，请重新编辑确认后保存数据！')
                                this.pageLoading = false
                                this.$parent.clearAllInterval()

                                if (this.loadingInterval) {
                                    clearInterval(this.loadingInterval)
                                    this.loadingInterval = null
                                }
                                this.cancelLoading()
                            }
                        })
                        .catch(err => {
                            // 待处理
                            this.handleClosed(type)

                            this.getStepList()
                        })
                }
            },

            // 解除 按钮loading 状态 -- over
            cancelLoading() {
                setTimeout(() => {
                    this.infoDialog.btnLoading = false
                    this.agreementDialog.btnLoading = false
                    this.phoneDialog.btnLoading = false
                    this.fileDialog.btnLoading = false
                }, 2000)
            },

            // 定时器 loading状态 查询
            onLoading(type, accountId) {
                // 页面loading
                this.pageLoading = true
                let text = ''
                switch (type) {
                    case 0:
                        this.loadingTime = 15
                        text = '基本信息仍处于审核中，请稍候再试！'
                        break
                    case 3:
                        this.loadingTime = 5
                        text = '协议签署状态仍处于审核中，请稍候再试！'
                        break
                    case 4:
                        this.loadingTime = 5
                        text = '手机号绑定状态仍处于审核中，请稍候再试！'
                        break
                    case 1:
                        this.loadingTime = 5
                        text = '影像件审核状态仍处于审核中，请稍候再试！'
                        break
                }

                this.loadingInterval = setInterval(() => {
                    // 时间递减
                    this.loadingTime--;

                    // 为0 时销毁定时器
                    if (this.loadingTime === 0) {
                        clearInterval(this.loadingInterval)
                        this.loadingInterval = null
                        this.$message.warning(text)
                        this.handleClosed(type)
                        return
                    }

                    // 根据类型查对应的状态 --- 营业执照不调用接口
                    if (type !== 1) {
                        this.getStepStatus(type, accountId)
                    }
                }, 1000)
            },

            // 弹窗关闭前事件
            onBeforeClose() {
                // 如果状态已通过  直接关闭
                let _item = this.curStepList.find(x => x.key === this.curKey)
                this.handleClosed(_item?.type)

                if (_item?.isFlag === 1) {
                    setTimeout(() => {
                        this.applyDialog.btnLoading = false
                    }, 800)
                    return
                }

                // // 否则  页面加载loading
                // if (type !== 1) {
                // 	this.onLoading(_item?.type, this.infoObj.accountId, true)
                // }
            },

            // 弹窗关闭事件
            handleClosed(type) {
                // this.infoDialog.visible = false
                switch (type) {
                    // 基本信息弹窗关闭事件
                    case 0:
                        this.infoDialog.visible = false
                        this.infoDialog.btnLoading = false

                        this.applyDialog.btnLoading = false
                        break
                    // 协议签署
                    case 3:
                        this.agreementDialog.visible = false

                        if (this.agreeInterval) {
                            clearInterval(this.agreeInterval)
                            this.agreeInterval = null
                        }
                        this.agreeTime = 5
                        break
                    // 手机号
                    case 4:
                        this.phoneDialog.visible = false
                        this.phoneDialog.btnLoading = false

                        this.phoneDialog.codeText = '点击获取授权码'
                        this.phoneDialog.codeDisabled = false
                        this.phoneCount = 60
                        break
                    // 影像件
                    case 1:
                        this.fileDialog.visible = false
                        this.fileDialog.btnLoading = false
                        break
                }

                type !== 0 ? this.applyDialog.btnLoading = true : ''

                // setTimeout(() => {
                // 	this.applyDialog.btnLoading = false
                // }, 800)

                // 重载状态
                // this.getStepList()

                // 清除定时器相关
                if (this.loadingInterval) {
                    clearInterval(this.loadingInterval)
                    this.loadingInterval = null
                }
                this.loadingTime = 15
                this.pageLoading = false

                if (this.codeInterval) {
                    clearInterval(this.codeInterval)
                    this.codeInterval = null
                }
            },

            // 步骤弹窗关闭事件
            onClosedAccount() {
                this.$emit('onClosedAccount')
            },

            // 图片是否可编辑
            picMode(curType) {
                let isView = this.fileDialog.mode === 'view'
                let isLicenseView = this.licenseMode === 'view' || this.licenseFlag === 1 || this.licenseFlag === 0
                let isCardView = this.cardMode === 'view' || this.cardFlag === 0 || this.cardFlag === 1

                switch (curType) {
                    case 1:
                        return isView || isLicenseView ? 'view' : 'add'
                    case 2:
                        return isView || isCardView ? 'view' : 'add'
                }
            },

            // 图片是否可编辑
            picDisabled(type) {
                return false
                if (this.mode === 'view') {
                    return true
                }
                let _list = this.baseInfo.list
                let status = false
                if (_list && _list.length > 0) {
                    let _type = _list.find((x) => x.type === type)

                    if (_type && _type.state !== 2) {
                        status = true
                    }
                }

                return status
            },
        },
        computed: {
            ...mapState('dict', {
                khh: (state) => state.projectDict.khh,
                qylx: state => state.projectDict.dwlx,
                zjlx: state => state.projectDict.smzjlx,
            }),

            // 基本信息是否可编辑
            infoDisabled() {
                return this.infoDialog.mode === 'view'
            },

            // 是否可编辑
            isDisabled() {
                return false
                let status = false
                if (this.mode === 'view') {
                    status = true
                } else {
                    let _state = this.checkState === 1 || this.checkState === 0
                    status = _state && this.disabled
                }
                return status
            },

            // 是否展示附件 上传按钮
            showFileBtn() {
                let isView = this.fileDialog.mode === 'add'
                let isLicenseEdit = this.licenseFlag === 2 || this.licenseFlag === -1
                let isCardEdit = this.cardFlag === 2 || this.licenseFlag === -1

                return (isLicenseEdit && isView) || (isCardEdit && isView)
            },

            // 文字提示
            errorText() {
                if (this.licenseFlag === 2 && this.cardFlag === 2) {
                    return '营业执照、身份证照片 审核失败，请重新上传!'
                } else if (this.licenseFlag === 2) {
                    return '营业执照 审核失败，请重新上传!'
                } else {
                    return '身份证照片 审核失败，请重新上传!'
                }
            },

            // 步骤数组
            stepList() {
                switch (this.applyDialog.mode) {
                    case 'account':
                        return [
                            {
                                isFlag: -1,
                                key: '1001',
                                type: 0,
                                sname: '设置企业基本信息',
                            },
                            {
                                isFlag: -1,
                                key: '1002',
                                type: 3,
                                sname: '签署会员协议',
                            },
                            {
                                isFlag: -1,
                                key: '1003',
                                type: 4,
                                sname: '绑定手机号',
                            },
                            {
                                isFlag: -1,
                                key: '1004',
                                type: 1,
                                sname: '上传影像材料',
                                title: '（当前步骤，影像资料上传平台会进行审核）',
                            },
                        ]
                    default:
                        return [
                            {
                                isFlag: -1,
                                key: '1001',
                                type: 0,
                                sname: '设置企业基本信息',
                            },
                            {
                                isFlag: -1,
                                key: '1002',
                                type: 3,
                                sname: '签署会员协议',
                            },
                            {
                                isFlag: -1,
                                key: '1003',
                                type: 4,
                                sname: '绑定手机号',
                            },
                        ]
                }
            },

            // 上传接口地址
            uploadUrl() {
                return this.$uploadUrl
            },
        },
        watch: {
            // 监听步骤弹窗的显示
            'applyDialog.visible': {
                handler: function (val) {
                    if (val) {
                        // this.applyDialog.btnLoading = true
                        this.getStepList(true)
                    }
                },
                deep: true,
            },
        },
    }
</script>

<style scoped lang="less">
    .apply-container {
        padding: 0px 20px 10px;

        .apply-title {
            font-size: 14px;
            line-height: 26px;
            color: #2671cc;
            margin-bottom: 10px;
        }

        @defaultColor: #eee;
        @successColor: #72aa2c;

        .progress-box {
            flex: 1;
            width: 20%;
            height: 40px;
            line-height: 40px;
            background-color: @defaultColor;
            color: #666;
            position: relative;
            padding-left: 55px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                border: 20px solid @defaultColor;
                border-left-color: #ffffff;
            }

            &:after {
                content: '';
                position: absolute;
                right: -20px;
                top: 0;
                border: 20px solid transparent;
                border-left-color: @defaultColor;
                background-color: #fff;
            }

            &:nth-of-type(1):before {
                content: unset;
            }

            &:last-child:after {
                content: unset;
            }

            .serial {
                position: absolute;
                left: 30px;
                top: 10px;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                background-color: #999;
                border-radius: 50%;
                color: #fff;
                font-size: 12px;
            }
        }

        .success-box {
            color: #fff;
            background-color: @successColor;

            &:before {
                border-color: @successColor;
                border-left-color: #fff;
            }

            &:after {
                border-left-color: @successColor;
            }

            .serial {
                color: @successColor;
                background-color: #fff;
            }
        }

        .apply-text {
            padding: 10px 0;

            .text-block {
                line-height: 40px;
                font-size: 14px;
            }

            .text-tips {
                line-height: 25px;
                color: #862386;
                font-size: 13px;
            }

            .text-icon {
                font-size: 20px;
                background-color: #fdf6ec;
                vertical-align: middle;
                margin-top: -2px;
                margin-right: 10px;
                border-radius: 50%;
            }

            .success-icon {
                color: #72aa2c;
            }

            .warning-icon {
                color: #e6a23c;
            }

            .error-icon {
                color: #fff;
                background: #ff5b64;
            }

            .color-red {
                color: red;
            }
        }
    }

    .agreement-main {
        height: calc(100% - 60px);

        .footer {
            position: absolute;
            bottom: 30px;
            width: 100%;
            left: 0;
        }
    }

    .agreement-text {
        margin-bottom: 20px;
        line-height: 26px;
        color: #256ccb;
        cursor: pointer;
    }

    .phone-text {
        font-size: 14px;
        line-height: 26px;
        color: #2671cc;
        margin-bottom: 10px;
    }

    .error-header {
        font-size: 14px;
        margin-bottom: 15px;

        span {
            color: #ff3333;
        }
    }

    .drop-bank {
        position: absolute;
        background-color: #fff;
        display: none;
    }

    .file-img {
        width: 190px;
        height: 120px;
    }
</style>
<style lang="less">
    .loading-class {
        font-size: 20px;
    }

    html, body {
        height: 100%;
    }

    .branch-bank {
        .el-scrollbar__view {
            padding-top: 34px;
        }

        .btn-select {
            position: absolute;
            top: 0;
            width: 100%;
            background-color: #fff;
            z-index: 1;
            left: 0;
            text-align: right;
            color: #256ccb;
        }
    }
</style>
